import { render } from "./Singleinput.vue?vue&type=template&id=d050c3a2"
import script from "./Singleinput.vue?vue&type=script&lang=js"
export * from "./Singleinput.vue?vue&type=script&lang=js"

import "./Singleinput.vue?vue&type=style&index=0&id=d050c3a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__